export const getUnrealPnl = (position: number, exposure: number, marketPrice: number, avgCost: number) =>
  position > 0
    ? position * (marketPrice - avgCost)
    : position < 0
      ? Math.abs(position) * (avgCost - marketPrice)
      : 0;
